//React
import * as React from 'react';

function fRenderGridCell(x, y, ratioX, ratioY)
{
    var cLayoutCSS = {
        position: "absolute",
        left: (100 * x * ratioX) + "%",
        top: (100 * y * ratioY) + "%",
        width: (100 * ratioX) + "%",
        height: (100 * ratioY) + "%",
        margin: 0,
        border: 0,
        textAlign: "center",
        border: "1px dashed black",
        overflow: "hidden"
    };

    return <p style={cLayoutCSS}>{x + ", " + y}</p>;
}

function fRenderGrid(cMake)
{
    var asHtml = [];
    var ratioX = 1/cMake.iSizeX;
    var ratioY = 1/cMake.iSizeY;
    
    for(let x=0; x<cMake.iSizeX; x++)
    {
        for(let y=0; y<cMake.iSizeY; y++)
        {
            asHtml.push(fRenderGridCell(x,y,ratioX,ratioY))
        }
    }

    return asHtml;
}

function DebugWidget({cMake})
{
    return (
        <div id="widget_debug">
        {
            fRenderGrid(cMake)
        }
        </div>
    );
}

export default DebugWidget